import { resolveErrorToast } from '@/shared/lib/error-messages';
import type { ErrorCodeMap, ToastErrorPayload } from '@/shared/lib/error-messages';
import { useToastStore } from '@/store';

/**
 * One-liner for the `resolveErrorToast` → toast-store pipeline used across
 * features. Keeps call-sites focused on the fallback copy that matters to
 * them, not the plumbing.
 */
export function showErrorToast(
  err: unknown,
  fallback: ToastErrorPayload,
  overrides?: ErrorCodeMap,
): void {
  const { title, body } = resolveErrorToast(err, fallback, overrides);
  useToastStore.getState().show(body, 'error', title);
}

/** Mirror for success toasts; keeps the call-site symmetric. */
export function showSuccessToast(title: string, body: string): void {
  useToastStore.getState().show(body, 'success', title);
}

/** Figma wide success toast — title + multi-line body (roster, training, etc.). */
export function showWideSuccessToast(title: string, body: string): void {
  useToastStore.getState().show(body, 'success', title, { layout: 'wide' });
}
